// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"p3F8zjJdwdAVE52n292Ox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/overlay/styles.scss
// module id = 1282
// module chunks = 0